/**
 * <mta-carousel> — progress bar + counter for snippets/mta-carousel.liquid.
 * The scrolling itself is Dwell's <slideshow-component>; this only reads the
 * scroller position and mirrors it into the progress bar and "n/N" counter.
 */
class MtaCarousel extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('slideshow-slides');
    this.bar = this.querySelector('[data-mta-progress-bar]');
    this.current = this.querySelector('[data-mta-progress-current]');
    this.slides = Array.from(this.querySelectorAll('slideshow-slide'));

    if (!this.scroller) return;

    this.scroller.addEventListener('scroll', this.#schedule, { passive: true });
    this.addEventListener('slideshow:select', this.#onSelect);
    window.addEventListener('resize', this.#schedule, { passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener('scroll', this.#schedule);
    this.removeEventListener('slideshow:select', this.#onSelect);
    window.removeEventListener('resize', this.#schedule);
  }

  #frame = 0;

  #schedule = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#update();
    });
  };

  #onSelect = (event) => {
    const index = event?.detail?.index;
    if (typeof index === 'number' && this.current) this.current.textContent = String(index + 1);
    this.#schedule();
  };

  #update() {
    const el = this.scroller;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    const visible = max > 0 ? el.clientWidth / el.scrollWidth : 1;
    const position = max > 0 ? el.scrollLeft / max : 0;
    const width = Math.min(1, visible + (1 - visible) * position);

    if (this.bar) this.bar.style.width = `${Math.round(width * 1000) / 10}%`;

    if (this.current && this.slides.length) {
      const index = Math.round((el.scrollLeft / Math.max(1, el.scrollWidth)) * this.slides.length);
      this.current.textContent = String(Math.min(this.slides.length, index + 1));
    }
  }
}

if (!customElements.get('mta-carousel')) {
  customElements.define('mta-carousel', MtaCarousel);
}
